import { OutsideServiceCosts } from '@interfaces/outside-service-costs';
import { getCall } from '@services/rest-service';

// Retrieves all the booster allowances from cosmos
export const getOutsideServiceCosts = (): Promise<OutsideServiceCosts[]> => {
  return getCall<OutsideServiceCosts[]>('outside-service-costs');
};